import React from 'react'
import { CircularProgress, Divider, Grid, IconButton, makeStyles } from '@material-ui/core'
import { ModifyLiabilityCoverage } from './ModifyLiabilityCoverage'
import { ModifyHullSection } from './ModifyHullSection'
import { ModifyAdditionalCoverages } from './ModifyAdditionalCoverages'
import { ActionsSection } from './ActionsSection'
import { ModifyNumberOfDronesOperate } from './ModifyNumberOfDronesOperate'
import './Modify.scss'
import { ModificationContextStore } from '../../../../context/ModificationContext'
import ModifyNamedInsured from './ModifyNamedInsured'
import { Clear } from '@material-ui/icons'
import { awaitWithLoading } from '../../../../services/utils'

const useStyles = makeStyles((theme) => ({
    divider: {
        color: 'white',
    },
}))

export const ModifyPolicySection = ({ insurance, closeDialog, isRenewal }) => {
    const modificationContext = React.useContext(ModificationContextStore)
    const modificationObject = isRenewal ? modificationContext.subscription : modificationContext.insurance
    const classes = useStyles()

    return (
        <div className="full-width midterm-modal-container">
            <div className="modify-title midterm-modal-title">
                <div className='midterm-modal-title-text'>
                    {isRenewal ? 'Edit renewal policy' : 'Edit policy'}
                </div>
                <IconButton 
                    onClick={async () => {
                        await awaitWithLoading(modificationContext.getPolicyDetails())
                        closeDialog()
                    }} 
                    style={{ marginRight: '2rem' }}
                >
                    <Clear />
                </IconButton>
            </div>
            {modificationContext.liabilityLimitOptions ? (
                <div className='midterm-modal-content'>
                    <ModifyNamedInsured 
                        isRenewal={isRenewal} 
                        modificationObject={modificationObject} 
                        className="modify-section-component" 
                    />
                    <Divider classes={{ root: classes.divider }} />
                    <ModifyLiabilityCoverage 
                        modificationObject={modificationObject} 
                        isRenewal={isRenewal} 
                        className="modify-section-component" 
                        insurance={insurance}
                    />
                    <Divider classes={{ root: classes.divider }} />
                    <ModifyNumberOfDronesOperate 
                        modificationObject={modificationObject} 
                        isRenewal={isRenewal}
                    />
                    <Divider classes={{ root: classes.divider }} />
                    <ModifyHullSection 
                        modificationObject={modificationObject} 
                        isRenewal={isRenewal}
                    />
                    <Divider classes={{ root: classes.divider }} />
                    <ModifyAdditionalCoverages 
                        insurance={insurance} 
                        modificationObject={modificationObject} 
                        isRenewal={isRenewal}
                    />
                </div>
            ) : (
                <Grid 
                    container 
                    justifyContent='center' 
                    alignItems='center' 
                    className='margin-top-basic margin-bottom-basic' 
                    style={{ flexGrow: 1 }}
                >
                    <CircularProgress />
                </Grid>
            )}
            <div className='midterm-modal-actions-container'>
                <ActionsSection 
                    isRenewal={isRenewal} 
                    closeDialog={async () => {
                        await modificationContext.getPolicyDetails()
                        closeDialog()
                    }}
                />
            </div>
        </div>
    )
}